import styled from 'styled-components';

const Container = styled.div`
  background-color: #eeeeee;
`;

interface IProps {
  children: React.ReactNode;
}

const RootContainer = (props: IProps) => {
  return <Container>{props.children}</Container>;
};

export default RootContainer;
